import * as React from 'react';
import * as baseUI from '#packages/baseUI';
import _ from 'lodash';
import type {
  GradientCircle,
  GradientLinear,
  GradientEllipse,
  GradientConic,
  GradientMesh,
} from '@wix/document-services-types';

export interface ColorPickerValues {
  color:
    | string
    | GradientLinear
    | GradientCircle
    | GradientEllipse
    | GradientConic
    | GradientMesh;
  alpha: number;
}

export interface ContainerFillControlProps {
  colorPickerValues: ColorPickerValues;
  colorPickerProps: any;
  updateStyle: (value: ColorPickerValues) => void;
  panelMode: string;
}

const ContainerFillsControl: React.FC<ContainerFillControlProps> = ({
  colorPickerValues,
  colorPickerProps,
  updateStyle,
  panelMode,
}) => {
  const { color, alpha } = colorPickerValues;
  const updateStyleIfApplicable = (val: ColorPickerValues) => {
    if (_.isEqual(val, colorPickerValues)) return;

    updateStyle(val);
  };

  //prevent gradient in thumbnail when skin doesn't support it
  if (typeof color !== 'string' && panelMode === 'solid') {
    updateStyle({ color: '#FFFFFF', alpha });
  }

  return (
    <baseUI.colorPickerInputWithOpacity
      label={'CustomDesign_FillColor_BGColor&Opacity'}
      value={colorPickerValues}
      onChange={updateStyleIfApplicable}
      panelMode={panelMode}
      automationId="bg"
      {...colorPickerProps}
    />
  );
};

ContainerFillsControl.displayName = 'containerFillsControl';

export default ContainerFillsControl;
